import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        snackbarModel: {
            snackbar: false,
            y: 'top',
            x: null,
            mode: '',
            timeout: 3000,
            message: ''
        }
    },
    mutations: {
        showSnackbar(state, data: any) {
            state.snackbarModel.message = data.message;
            state.snackbarModel.snackbar = true;
        }
    },
    actions: {
        showSnackbar({commit}, data: any) {
            commit("showSnackbar", data);
        }
    },
});
